import {
  QUALIFIES_LIST_REQUEST,
  QUALIFIES_LIST_SUCCESS,
  QUALIFIES_LIST_FAIL,
} from "../constant/QualifiesConstant";
import api from "../core/api";

export const getQualifiesList = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: QUALIFIES_LIST_REQUEST,
    });

    const { data } = await api.get(`/qualifies`);

    var dt = data.Result;

    if (dt.includes("Error")) {
      dispatch({
        type: QUALIFIES_LIST_FAIL,
        payload: dt,
      });
    } else {
      dispatch({
        type: QUALIFIES_LIST_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: QUALIFIES_LIST_FAIL,
      payload:
        error.response && error.response.data
          ? error.response.data
          : error.message,
    });
  }
};
